/**
 * Loading spinner component.
 *
 * @module components/ui/Spinner
 */

import { clsx } from 'clsx';
import { Loader2 } from 'lucide-react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeStyles = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

/**
 * Loading spinner component
 */
export function Spinner({ size = 'md', className }: SpinnerProps) {
  return <Loader2 className={clsx('animate-spin text-primary-600', sizeStyles[size], className)} />;
}

/**
 * Full page loading spinner
 */
export function LoadingPage() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center">
        <Spinner size="lg" />
        <p className="mt-4 text-sm text-gray-500">Loading...</p>
      </div>
    </div>
  );
}

/**
 * Loading overlay for cards/sections
 */
export function LoadingOverlay() {
  return (
    <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
      <Spinner size="md" />
    </div>
  );
}
